// api
import AxiosInstanceCreator from 'services/api';

// models
import {
  ReqEntryHistoryExcelMonthly,
  ReqEntryHistoryExcelToday,
  ReqEntryHistoryExcelWeekly,
  ReqEntrySearch
} from 'modules/entry';
import { ResExcel, ResPostTrainingBatch, ResPostUserBatch } from '../models/excel.model';

// libraries
import qs from 'qs';

const excelInstance = new AxiosInstanceCreator().create();

export const excelApi = {
  /**
   * 엑셀 Batch Enroll
   * @param {type, file} data
   * @returns
   */
  async postUserBatch(formData: FormData): Promise<ResPostUserBatch> {
    return excelInstance
      .post(`/excel/user-management/enroll`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  async postTrainingBatch(formData: FormData): Promise<ResPostTrainingBatch> {
    return excelInstance
      .post(`/excel/safety-training/enroll`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((res) => res.data);
  },

  /**
   * 엑셀 템플릿 다운로드
   * @param {*} data
   * @returns
   */
  async fetchUserBatchTemplate(): Promise<ArrayBuffer> {
    return excelInstance
      .get(`/excel/user-management/download/template`, { responseType: 'arraybuffer' })
      .then((res) => res.data);
  },

  async fetchTrainingBatchTemplate(): Promise<ArrayBuffer> {
    return excelInstance
      .get(`/excel/safety-training/download/template`, { responseType: 'arraybuffer' })
      .then((res) => res.data);
  },

  async fetchTbmStatusExcelFile(tbmId: string): Promise<ArrayBuffer> {
    return excelInstance
      .get(`/tbm/export/excel?tbmId=${tbmId}`, { responseType: 'arraybuffer' })
      .then((res) => res.data);
  },

  async fetchEntryExcelFile(request: ReqEntrySearch): Promise<ArrayBuffer> {
    return excelInstance
      .get(`/excel/entry-management/export?${qs.stringify(request)}`, {
        responseType: 'arraybuffer'
      })
      .then((res) => res.data);
  },

  async fetchEntryHistoryTodayExcelFile(request: ReqEntryHistoryExcelToday): Promise<ArrayBuffer> {
    return excelInstance
      .get(`/excel/entry-history/export/today?${qs.stringify(request)}`, {
        responseType: 'arraybuffer'
      })
      .then((res) => res.data);
  },

  async fetchEntryHistoryWeeklyExcelFile(
    request: ReqEntryHistoryExcelWeekly
  ): Promise<ArrayBuffer> {
    return excelInstance
      .get(`/excel/entry-history/export/weekly?${qs.stringify(request)}`, {
        responseType: 'arraybuffer'
      })
      .then((res) => res.data);
  },

  async fetchEntryHistoryMonthlyExcelFile(
    request: ReqEntryHistoryExcelMonthly
  ): Promise<ArrayBuffer> {
    return excelInstance
      .get(`/excel/entry-history/export/monthly?${qs.stringify(request)}`, {
        responseType: 'arraybuffer'
      })
      .then((res) => res.data);
  },

  /**
   * 엑셀 다운로드 리스트
   * @param {type, company, workerType, passport, keyword} data
   * @returns
   */
  async fetchExcels(query: string): Promise<ResExcel> {
    return await excelInstance
      .post(`/excel/user-management/download/list?${query}`, { responseType: 'arraybuffer' })
      .then((res) => res);
  }
};
